import Backbone from 'backbone';
import Cache from 'root/cache';
import Util from 'root/module/util';

export default Backbone.Model.extend({
    defaults: {
        display_name     : '',
        subdomain        : '',
        logo_url         : '',
        join_code        : '',
        join_project_ids : '',
        enforce_2fa      : false
    },

    getName: function() {
        return this.get('display_name') || this.get('subdomain') || 'Userback #' + Util.padLeft(this.id, '000000');
    },

    getUrl: function() {
        if (this.get('subdomain')) {
            return 'https://' + this.get('subdomain') + Cache.app.configs.workspace_host;
        } else {
            return Cache.app.host;
        }
    }
});